import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";

export const updatePromocodeApi = createAsyncThunk("promocode/update", async (promocodeData) => {
  try {
    console.log(promocodeData);
    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;
    return await fetch(
      `${process.env.REACT_APP_VERSEL_API}/api/user/promocode/updateById/${promocodeData.promocodeId}`,{
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenData}`
        },
        body: JSON.stringify(promocodeData.data)
      }
    ).then((res) => res.json());
  } catch (error) {
    swal("Error", error, "info");
    return error;
  }
});

const UpdatePromocodeSlicer = createSlice({
  name: "Update Promocode",
  initialState: {
    loading: false,
    response: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(updatePromocodeApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updatePromocodeApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
    builder.addCase(updatePromocodeApi.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.message === "Promocode Updated Successfully") {
        state.response = action.payload;
      } else {
        state.error = action.payload.message;
      }
    });
  },
});

export default UpdatePromocodeSlicer.reducer;
